
/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/
(function(Flits) {
  /* To load js in all pages */
  if(Flits.Metafields.IS_SOCIAL_LOGIN_PAID && Flits.Metafields.IS_SOCIAL_LOGIN_ENABLE){
    if(window.flitsObjects.allCssJs.socialLoginJs){
      Flits.LoadStyleScript('socialLoginJs',window.flitsObjects.allCssJs.socialLoginJs.url);
    }
  }
  var ajaxWishlistViewFunction = function(xhrOrFetch) {
    var url = this._url;

    (-1 !== url.indexOf("all?sort_by")) && Flits.dispatchEvent("Flits:AjaxWishlist", { 
      response: this,
      xhrOrFetch: xhrOrFetch
    })
  };
  Flits.addAjaxEvents(ajaxWishlistViewFunction);
  Flits.addFetchEvents(ajaxWishlistViewFunction);

  Flits(document).on("Flits:AjaxWishlist", function(){
    setTimeout(function(){
      let collectionBtn = Flits(".flits-wishlist-colection");
      parseInt(Flits.wishlistButton.settings.isCountEnable) && Flits(collectionBtn).find(".flits-wls-count-btn").css("display", "flex"),
        Flits(collectionBtn).show(),
        Flits(".flits-wishlist-colection:not(.flits-template)").parent().attr("data-flits", "wishlist-collection-parent");
    }, 1000);
    setTimeout(function(){
      Flits('.flits-wishlist-colection').each(function(index,ele){
      	let wishProdHandle = Flits(ele).find('.flits-wls-button').attr('data-flits-product-handle');
        if(Flits.isProductAddedInWishlist(wishProdHandle)){ 
          Flits(ele).find('.flits-wls-button').removeClass("flits-wls-inactive")
          Flits(ele).find('.flits-wls-button').addClass("flits-wls-active")
          Flits(ele).find('.flits-wls-button').attr("data-tippy-content",Flits.t('Flits.locals.wishlisted_product_page.remove_from_wishlist_button', 'Remove from Wishlist'))
        }
      });
    },2000);
  });

  
  Flits(document).on("Flits:Loaded",function (event) {
    if(Flits.Metafields.IS_WISHLIST_PAID && Flits.Metafields.IS_WISHLIST_ENABLE){
    Flits.LoadStyleScript('wishlistJs',window.flitsObjects.allCssJs.wishlistJs.url);
  }
  })
   Flits(document).on('Flits:wishlistButton:Loaded', function(event){
//     if (Flits.request.page_type == 'index' || Flits.request.page_type == 'product') {
      let collectionBtn = Flits('.flits-wishlist-colection');
      parseInt(Flits.wishlistButton.settings.isCountEnable) && Flits(collectionBtn).find('.flits-wls-count-btn').css('display', 'flex'),
        Flits(collectionBtn).show(),
        Flits('.flits-wishlist-colection:not(.flits-template)').parent().attr('data-flits', 'wishlist-collection-parent');
//     }
  });
}(Flits));
